export default "__VITE_ASSET__C74WFHGD__"